export default {
  methods: {
    // format formats the provided raw value with the provided mask.
    format (raw, mask) {
      let i = 0
      if (!raw) return raw
      const v = raw.toString()
      return mask.replace(/#/g, _ => v[i++] ?? '')
    }
  }
}
